export interface Country {
  name: string;
  nameFr: string;
  flag: string;
  code: string;
}

export const COUNTRIES: Country[] = [
  { code: "AF", name: "Afghanistan", nameFr: "Afghanistan", flag: "🇦🇫" },
  { code: "AL", name: "Albania", nameFr: "Albanie", flag: "🇦🇱" },
  { code: "DZ", name: "Algeria", nameFr: "Algérie", flag: "🇩🇿" },
  { code: "AD", name: "Andorra", nameFr: "Andorre", flag: "🇦🇩" },
  { code: "AO", name: "Angola", nameFr: "Angola", flag: "🇦🇴" },
  { code: "AG", name: "Antigua and Barbuda", nameFr: "Antigua-et-Barbuda", flag: "🇦🇬" },
  { code: "AR", name: "Argentina", nameFr: "Argentine", flag: "🇦🇷" },
  { code: "AM", name: "Armenia", nameFr: "Arménie", flag: "🇦🇲" },
  { code: "AU", name: "Australia", nameFr: "Australie", flag: "🇦🇺" },
  { code: "AT", name: "Austria", nameFr: "Autriche", flag: "🇦🇹" },
  { code: "AZ", name: "Azerbaijan", nameFr: "Azerbaïdjan", flag: "🇦🇿" },
  { code: "BS", name: "Bahamas", nameFr: "Bahamas", flag: "🇧🇸" },
  { code: "BH", name: "Bahrain", nameFr: "Bahreïn", flag: "🇧🇭" },
  { code: "BD", name: "Bangladesh", nameFr: "Bangladesh", flag: "🇧🇩" },
  { code: "BB", name: "Barbados", nameFr: "Barbade", flag: "🇧🇧" },
  { code: "BY", name: "Belarus", nameFr: "Biélorussie", flag: "🇧🇾" },
  { code: "BE", name: "Belgium", nameFr: "Belgique", flag: "🇧🇪" },
  { code: "BZ", name: "Belize", nameFr: "Belize", flag: "🇧🇿" },
  { code: "BJ", name: "Benin", nameFr: "Bénin", flag: "🇧🇯" },
  { code: "BT", name: "Bhutan", nameFr: "Bhoutan", flag: "🇧🇹" },
  { code: "BO", name: "Bolivia", nameFr: "Bolivie", flag: "🇧🇴" },
  { code: "BA", name: "Bosnia and Herzegovina", nameFr: "Bosnie-Herzégovine", flag: "🇧🇦" },
  { code: "BW", name: "Botswana", nameFr: "Botswana", flag: "🇧🇼" },
  { code: "BR", name: "Brazil", nameFr: "Brésil", flag: "🇧🇷" },
  { code: "BN", name: "Brunei", nameFr: "Brunei", flag: "🇧🇳" },
  { code: "BG", name: "Bulgaria", nameFr: "Bulgarie", flag: "🇧🇬" },
  { code: "BF", name: "Burkina Faso", nameFr: "Burkina Faso", flag: "🇧🇫" },
  { code: "BI", name: "Burundi", nameFr: "Burundi", flag: "🇧🇮" },
  { code: "KH", name: "Cambodia", nameFr: "Cambodge", flag: "🇰🇭" },
  { code: "CM", name: "Cameroon", nameFr: "Cameroun", flag: "🇨🇲" },
  { code: "CA", name: "Canada", nameFr: "Canada", flag: "🇨🇦" },
  { code: "CV", name: "Cape Verde", nameFr: "Cap-Vert", flag: "🇨🇻" },
  { code: "CF", name: "Central African Republic", nameFr: "République centrafricaine", flag: "🇨🇫" },
  { code: "TD", name: "Chad", nameFr: "Tchad", flag: "🇹🇩" },
  { code: "CL", name: "Chile", nameFr: "Chili", flag: "🇨🇱" },
  { code: "CN", name: "China", nameFr: "Chine", flag: "🇨🇳" },
  { code: "CO", name: "Colombia", nameFr: "Colombie", flag: "🇨🇴" },
  { code: "KM", name: "Comoros", nameFr: "Comores", flag: "🇰🇲" },
  { code: "CG", name: "Congo", nameFr: "Congo", flag: "🇨🇬" },
  { code: "CD", name: "DR Congo", nameFr: "RD Congo", flag: "🇨🇩" },
  { code: "CR", name: "Costa Rica", nameFr: "Costa Rica", flag: "🇨🇷" },
  { code: "HR", name: "Croatia", nameFr: "Croatie", flag: "🇭🇷" },
  { code: "CU", name: "Cuba", nameFr: "Cuba", flag: "🇨🇺" },
  { code: "CY", name: "Cyprus", nameFr: "Chypre", flag: "🇨🇾" },
  { code: "CZ", name: "Czech Republic", nameFr: "République tchèque", flag: "🇨🇿" },
  { code: "DK", name: "Denmark", nameFr: "Danemark", flag: "🇩🇰" },
  { code: "DJ", name: "Djibouti", nameFr: "Djibouti", flag: "🇩🇯" },
  { code: "DM", name: "Dominica", nameFr: "Dominique", flag: "🇩🇲" },
  { code: "DO", name: "Dominican Republic", nameFr: "République dominicaine", flag: "🇩🇴" },
  { code: "TL", name: "East Timor", nameFr: "Timor oriental", flag: "🇹🇱" },
  { code: "EC", name: "Ecuador", nameFr: "Équateur", flag: "🇪🇨" },
  { code: "EG", name: "Egypt", nameFr: "Égypte", flag: "🇪🇬" },
  { code: "SV", name: "El Salvador", nameFr: "Salvador", flag: "🇸🇻" },
  { code: "GQ", name: "Equatorial Guinea", nameFr: "Guinée équatoriale", flag: "🇬🇶" },
  { code: "ER", name: "Eritrea", nameFr: "Érythrée", flag: "🇪🇷" },
  { code: "EE", name: "Estonia", nameFr: "Estonie", flag: "🇪🇪" },
  { code: "SZ", name: "Eswatini", nameFr: "Eswatini", flag: "🇸🇿" },
  { code: "ET", name: "Ethiopia", nameFr: "Éthiopie", flag: "🇪🇹" },
  { code: "FJ", name: "Fiji", nameFr: "Fidji", flag: "🇫🇯" },
  { code: "FI", name: "Finland", nameFr: "Finlande", flag: "🇫🇮" },
  { code: "FR", name: "France", nameFr: "France", flag: "🇫🇷" },
  { code: "GA", name: "Gabon", nameFr: "Gabon", flag: "🇬🇦" },
  { code: "GM", name: "Gambia", nameFr: "Gambie", flag: "🇬🇲" },
  { code: "GE", name: "Georgia", nameFr: "Géorgie", flag: "🇬🇪" },
  { code: "DE", name: "Germany", nameFr: "Allemagne", flag: "🇩🇪" },
  { code: "GH", name: "Ghana", nameFr: "Ghana", flag: "🇬🇭" },
  { code: "GR", name: "Greece", nameFr: "Grèce", flag: "🇬🇷" },
  { code: "GD", name: "Grenada", nameFr: "Grenade", flag: "🇬🇩" },
  { code: "GT", name: "Guatemala", nameFr: "Guatemala", flag: "🇬🇹" },
  { code: "GN", name: "Guinea", nameFr: "Guinée", flag: "🇬🇳" },
  { code: "GW", name: "Guinea-Bissau", nameFr: "Guinée-Bissau", flag: "🇬🇼" },
  { code: "GY", name: "Guyana", nameFr: "Guyana", flag: "🇬🇾" },
  { code: "HT", name: "Haiti", nameFr: "Haïti", flag: "🇭🇹" },
  { code: "HN", name: "Honduras", nameFr: "Honduras", flag: "🇭🇳" },
  { code: "HU", name: "Hungary", nameFr: "Hongrie", flag: "🇭🇺" },
  { code: "IS", name: "Iceland", nameFr: "Islande", flag: "🇮🇸" },
  { code: "IN", name: "India", nameFr: "Inde", flag: "🇮🇳" },
  { code: "ID", name: "Indonesia", nameFr: "Indonésie", flag: "🇮🇩" },
  { code: "IR", name: "Iran", nameFr: "Iran", flag: "🇮🇷" },
  { code: "IQ", name: "Iraq", nameFr: "Irak", flag: "🇮🇶" },
  { code: "IE", name: "Ireland", nameFr: "Irlande", flag: "🇮🇪" },
  { code: "IL", name: "Israel", nameFr: "Israël", flag: "🇮🇱" },
  { code: "IT", name: "Italy", nameFr: "Italie", flag: "🇮🇹" },
  { code: "CI", name: "Ivory Coast", nameFr: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "JM", name: "Jamaica", nameFr: "Jamaïque", flag: "🇯🇲" },
  { code: "JP", name: "Japan", nameFr: "Japon", flag: "🇯🇵" },
  { code: "JO", name: "Jordan", nameFr: "Jordanie", flag: "🇯🇴" },
  { code: "KZ", name: "Kazakhstan", nameFr: "Kazakhstan", flag: "🇰🇿" },
  { code: "KE", name: "Kenya", nameFr: "Kenya", flag: "🇰🇪" },
  { code: "KI", name: "Kiribati", nameFr: "Kiribati", flag: "🇰🇮" },
  { code: "KW", name: "Kuwait", nameFr: "Koweït", flag: "🇰🇼" },
  { code: "KG", name: "Kyrgyzstan", nameFr: "Kirghizistan", flag: "🇰🇬" },
  { code: "LA", name: "Laos", nameFr: "Laos", flag: "🇱🇦" },
  { code: "LV", name: "Latvia", nameFr: "Lettonie", flag: "🇱🇻" },
  { code: "LB", name: "Lebanon", nameFr: "Liban", flag: "🇱🇧" },
  { code: "LS", name: "Lesotho", nameFr: "Lesotho", flag: "🇱🇸" },
  { code: "LR", name: "Liberia", nameFr: "Libéria", flag: "🇱🇷" },
  { code: "LY", name: "Libya", nameFr: "Libye", flag: "🇱🇾" },
  { code: "LI", name: "Liechtenstein", nameFr: "Liechtenstein", flag: "🇱🇮" },
  { code: "LT", name: "Lithuania", nameFr: "Lituanie", flag: "🇱🇹" },
  { code: "LU", name: "Luxembourg", nameFr: "Luxembourg", flag: "🇱🇺" },
  { code: "MG", name: "Madagascar", nameFr: "Madagascar", flag: "🇲🇬" },
  { code: "MW", name: "Malawi", nameFr: "Malawi", flag: "🇲🇼" },
  { code: "MY", name: "Malaysia", nameFr: "Malaisie", flag: "🇲🇾" },
  { code: "MV", name: "Maldives", nameFr: "Maldives", flag: "🇲🇻" },
  { code: "ML", name: "Mali", nameFr: "Mali", flag: "🇲🇱" },
  { code: "MT", name: "Malta", nameFr: "Malte", flag: "🇲🇹" },
  { code: "MH", name: "Marshall Islands", nameFr: "Îles Marshall", flag: "🇲🇭" },
  { code: "MR", name: "Mauritania", nameFr: "Mauritanie", flag: "🇲🇷" },
  { code: "MU", name: "Mauritius", nameFr: "Maurice", flag: "🇲🇺" },
  { code: "MX", name: "Mexico", nameFr: "Mexique", flag: "🇲🇽" },
  { code: "FM", name: "Micronesia", nameFr: "Micronésie", flag: "🇫🇲" },
  { code: "MD", name: "Moldova", nameFr: "Moldavie", flag: "🇲🇩" },
  { code: "MC", name: "Monaco", nameFr: "Monaco", flag: "🇲🇨" },
  { code: "MN", name: "Mongolia", nameFr: "Mongolie", flag: "🇲🇳" },
  { code: "ME", name: "Montenegro", nameFr: "Monténégro", flag: "🇲🇪" },
  { code: "MA", name: "Morocco", nameFr: "Maroc", flag: "🇲🇦" },
  { code: "MZ", name: "Mozambique", nameFr: "Mozambique", flag: "🇲🇿" },
  { code: "MM", name: "Myanmar", nameFr: "Myanmar", flag: "🇲🇲" },
  { code: "NA", name: "Namibia", nameFr: "Namibie", flag: "🇳🇦" },
  { code: "NR", name: "Nauru", nameFr: "Nauru", flag: "🇳🇷" },
  { code: "NP", name: "Nepal", nameFr: "Népal", flag: "🇳🇵" },
  { code: "NL", name: "Netherlands", nameFr: "Pays-Bas", flag: "🇳🇱" },
  { code: "NZ", name: "New Zealand", nameFr: "Nouvelle-Zélande", flag: "🇳🇿" },
  { code: "NI", name: "Nicaragua", nameFr: "Nicaragua", flag: "🇳🇮" },
  { code: "NE", name: "Niger", nameFr: "Niger", flag: "🇳🇪" },
  { code: "NG", name: "Nigeria", nameFr: "Nigéria", flag: "🇳🇬" },
  { code: "KP", name: "North Korea", nameFr: "Corée du Nord", flag: "🇰🇵" },
  { code: "MK", name: "North Macedonia", nameFr: "Macédoine du Nord", flag: "🇲🇰" },
  { code: "NO", name: "Norway", nameFr: "Norvège", flag: "🇳🇴" },
  { code: "OM", name: "Oman", nameFr: "Oman", flag: "🇴🇲" },
  { code: "PK", name: "Pakistan", nameFr: "Pakistan", flag: "🇵🇰" },
  { code: "PW", name: "Palau", nameFr: "Palaos", flag: "🇵🇼" },
  { code: "PS", name: "Palestine", nameFr: "Palestine", flag: "🇵🇸" },
  { code: "PA", name: "Panama", nameFr: "Panama", flag: "🇵🇦" },
  { code: "PG", name: "Papua New Guinea", nameFr: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
  { code: "PY", name: "Paraguay", nameFr: "Paraguay", flag: "🇵🇾" },
  { code: "PE", name: "Peru", nameFr: "Pérou", flag: "🇵🇪" },
  { code: "PH", name: "Philippines", nameFr: "Philippines", flag: "🇵🇭" },
  { code: "PL", name: "Poland", nameFr: "Pologne", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", nameFr: "Portugal", flag: "🇵🇹" },
  { code: "QA", name: "Qatar", nameFr: "Qatar", flag: "🇶🇦" },
  { code: "RO", name: "Romania", nameFr: "Roumanie", flag: "🇷🇴" },
  { code: "RU", name: "Russia", nameFr: "Russie", flag: "🇷🇺" },
  { code: "RW", name: "Rwanda", nameFr: "Rwanda", flag: "🇷🇼" },
  { code: "KN", name: "Saint Kitts and Nevis", nameFr: "Saint-Kitts-et-Nevis", flag: "🇰🇳" },
  { code: "LC", name: "Saint Lucia", nameFr: "Sainte-Lucie", flag: "🇱🇨" },
  { code: "VC", name: "Saint Vincent and the Grenadines", nameFr: "Saint-Vincent-et-les-Grenadines", flag: "🇻🇨" },
  { code: "WS", name: "Samoa", nameFr: "Samoa", flag: "🇼🇸" },
  { code: "ST", name: "São Tomé and Príncipe", nameFr: "São Tomé-et-Príncipe", flag: "🇸🇹" },
  { code: "SA", name: "Saudi Arabia", nameFr: "Arabie saoudite", flag: "🇸🇦" },
  { code: "SN", name: "Senegal", nameFr: "Sénégal", flag: "🇸🇳" },
  { code: "RS", name: "Serbia", nameFr: "Serbie", flag: "🇷🇸" },
  { code: "SC", name: "Seychelles", nameFr: "Seychelles", flag: "🇸🇨" },
  { code: "SL", name: "Sierra Leone", nameFr: "Sierra Leone", flag: "🇸🇱" },
  { code: "SG", name: "Singapore", nameFr: "Singapour", flag: "🇸🇬" },
  { code: "SK", name: "Slovakia", nameFr: "Slovaquie", flag: "🇸🇰" },
  { code: "SI", name: "Slovenia", nameFr: "Slovénie", flag: "🇸🇮" },
  { code: "SB", name: "Solomon Islands", nameFr: "Îles Salomon", flag: "🇸🇧" },
  { code: "SO", name: "Somalia", nameFr: "Somalie", flag: "🇸🇴" },
  { code: "ZA", name: "South Africa", nameFr: "Afrique du Sud", flag: "🇿🇦" },
  { code: "KR", name: "South Korea", nameFr: "Corée du Sud", flag: "🇰🇷" },
  { code: "SS", name: "South Sudan", nameFr: "Soudan du Sud", flag: "🇸🇸" },
  { code: "ES", name: "Spain", nameFr: "Espagne", flag: "🇪🇸" },
  { code: "LK", name: "Sri Lanka", nameFr: "Sri Lanka", flag: "🇱🇰" },
  { code: "SD", name: "Sudan", nameFr: "Soudan", flag: "🇸🇩" },
  { code: "SR", name: "Suriname", nameFr: "Suriname", flag: "🇸🇷" },
  { code: "SE", name: "Sweden", nameFr: "Suède", flag: "🇸🇪" },
  { code: "CH", name: "Switzerland", nameFr: "Suisse", flag: "🇨🇭" },
  { code: "SY", name: "Syria", nameFr: "Syrie", flag: "🇸🇾" },
  { code: "TW", name: "Taiwan", nameFr: "Taïwan", flag: "🇹🇼" },
  { code: "TJ", name: "Tajikistan", nameFr: "Tadjikistan", flag: "🇹🇯" },
  { code: "TZ", name: "Tanzania", nameFr: "Tanzanie", flag: "🇹🇿" },
  { code: "TH", name: "Thailand", nameFr: "Thaïlande", flag: "🇹🇭" },
  { code: "TG", name: "Togo", nameFr: "Togo", flag: "🇹🇬" },
  { code: "TO", name: "Tonga", nameFr: "Tonga", flag: "🇹🇴" },
  { code: "TT", name: "Trinidad and Tobago", nameFr: "Trinité-et-Tobago", flag: "🇹🇹" },
  { code: "TN", name: "Tunisia", nameFr: "Tunisie", flag: "🇹🇳" },
  { code: "TR", name: "Turkey", nameFr: "Turquie", flag: "🇹🇷" },
  { code: "TM", name: "Turkmenistan", nameFr: "Turkménistan", flag: "🇹🇲" },
  { code: "TV", name: "Tuvalu", nameFr: "Tuvalu", flag: "🇹🇻" },
  { code: "UG", name: "Uganda", nameFr: "Ouganda", flag: "🇺🇬" },
  { code: "UA", name: "Ukraine", nameFr: "Ukraine", flag: "🇺🇦" },
  { code: "AE", name: "United Arab Emirates", nameFr: "Émirats arabes unis", flag: "🇦🇪" },
  { code: "GB", name: "United Kingdom", nameFr: "Royaume-Uni", flag: "🇬🇧" },
  { code: "US", name: "United States", nameFr: "États-Unis", flag: "🇺🇸" },
  { code: "UY", name: "Uruguay", nameFr: "Uruguay", flag: "🇺🇾" },
  { code: "UZ", name: "Uzbekistan", nameFr: "Ouzbékistan", flag: "🇺🇿" },
  { code: "VU", name: "Vanuatu", nameFr: "Vanuatu", flag: "🇻🇺" },
  { code: "VA", name: "Vatican City", nameFr: "Vatican", flag: "🇻🇦" },
  { code: "VE", name: "Venezuela", nameFr: "Venezuela", flag: "🇻🇪" },
  { code: "VN", name: "Vietnam", nameFr: "Viêt Nam", flag: "🇻🇳" },
  { code: "YE", name: "Yemen", nameFr: "Yémen", flag: "🇾🇪" },
  { code: "ZM", name: "Zambia", nameFr: "Zambie", flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe", nameFr: "Zimbabwe", flag: "🇿🇼" },
];
